import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";
import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";

export class SportTypeStatisticTypesImageRequestParams extends ImageRequestParams {
  constructor(id: Number, width: Number, height: Number, color) {
    super({width, height});

    this.resourceName = `NewBrand25/SportTypes/StatisticTypes`;
    this.id = id;
    this.color = color;
    this.ratio = 3;
    this.c = null;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }

  get pathPostfix(): String {
    return `${this.versionPath}/${this.resourceName}/${this.theme}/${this.id}`;
  }

  get params(): * {
    const fallbackResourceName = this.resourceName.replaceAll('/', ':');

    return `${super.params},d_${fallbackResourceName}.svg`;
  }
}
